import React, { useCallback, useState } from 'react';
import { makeStyles, Typography, Button, ButtonBase } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import rou from '../../router';
import { classNames } from '../../utils';
import { SettingIcon } from '../Icon';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  tabHeader: ({ wrapHeader }) => ({
    display: 'flex',
    overflow: wrapHeader ? 'visible' : 'auto',
    gridGap: '1rem',
    justifyContent: wrapHeader ? 'flex-start' : 'space-between',
    flexWrap: wrapHeader ? 'wrap' : 'nowrap',
    alignItems: wrapHeader ? 'flex-start' : 'center',
    '& :last-child': {
      marginRight: '0',
    },
  }),
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '2.25rem',
    fontWeight: 'bold',
    marginBottom: '3.438rem',
  },
  tabBarBtnBox: ({ wrapHeader }) => ({
    display: 'flex',
    alignItems: 'center',
    gridGap: '0.625rem',
    flexWrap: wrapHeader ? 'wrap' : 'nowrap',
  }),
  tabButton: ({ width }) => ({
    minWidth: width ?? '10rem',
    height: '3.875rem',
    backgroundColor: '#538fff11',
    borderRadius: '0.75rem 0.75rem 0 0',
    textTransform: 'capitalize',
    position: 'relative',
    '&:hover': {
      background: '#538fff11',
    },
    '& .MuiButton-label': {
      fontFamily: 'NotoSans-Bold',
      whiteSpace: 'nowrap',
      fontSize: '1rem',
      fontWeight: '600',
      textAlign: 'center',
      color: '#538fff',
      opacity: 0.6,
    },
  }),
  selectBtn: {
    opacity: 1,
    backgroundColor: '#fff !important',
    fontWeight: 'bold',
    '& .MuiButton-label': {
      opacity: '1 !important',
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    '&:hover': {
      background: '#fff',
    },
  },
  setting: {
    width: '7.188rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    lineHeight: '1.25',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
  },
  redCircle: {
    borderRadius: '50%',
    backgroundColor: '#ff7270',
    width: '0.5rem',
    height: '0.5rem',
    position: 'absolute',
    top: '1.063rem',
    right: '1.188rem',
  },
}));

function TabBar(props) {
  const {
    data,
    setData,
    className,
    settingopen,
    isLogin,
    NotificationBtn,
    width,
    extraHandle = null,
    wrapHeader = false,
    inlineNotificationBtn = false,
  } = props;
  const classes = useStyles({ width, wrapHeader });
  const [ehandoverHideTab] = useState([10003, 10004]);
  const skipSeeting = () => {
    props.history.push(rou.bedstatusSettingRou.path);
  };
  const handleClick = useCallback(
    (item) => {
      const newData = data.map((curItem) => {
        if (curItem.id === item.id) {
          return { ...curItem, flag: true };
        } else {
          return { ...curItem, flag: false };
        }
      });
      if (_.isFunction(extraHandle)) {
        extraHandle(item);
      }
      setData(newData);
    },
    [data, extraHandle, setData]
  );

  const renderNotificationBtn = () => {
    if (!NotificationBtn) {
      return null;
    }
    return React.isValidElement(NotificationBtn) ? React.cloneElement(NotificationBtn) : <NotificationBtn />;
  };

  function settingContrl(Props) {
    if (Props) {
      return (
        <ButtonBase className={classes.setting} onClick={skipSeeting}>
          <SettingIcon style={{ marginRight: '0.5rem', fontSize: '1.25rem' }} />
          <Typography>Setting</Typography>
        </ButtonBase>
      );
    }
    return null;
  }
  return (
    <div className={className ? classNames(className, classes.root) : classes.root}>
      <div className={classes.tabHeader}>
        <div className={classes.tabBarBtnBox}>
          {data.map((item) => {
            let control = ehandoverHideTab.findIndex((tab) => {
              return tab === item.id;
            });
            return isLogin ? (
              <Button
                id={item.testID}
                key={item.id}
                className={item.flag ? classNames(classes.tabButton, classes.selectBtn) : classes.tabButton}
                onClick={() => {
                  handleClick(item);
                }}
              >
                {item.title}
                {item.status && <div className={classes.redCircle} />}
              </Button>
            ) : (
              control === -1 && (
                <Button
                  id={item.testID}
                  key={item.id}
                  className={item.flag ? classNames(classes.tabButton, classes.selectBtn) : classes.tabButton}
                  onClick={() => {
                    handleClick(item);
                  }}
                >
                  {item.title}
                  {item.status && <div className={classes.redCircle} />}
                </Button>
              )
            );
          })}
          {inlineNotificationBtn && renderNotificationBtn()}
        </div>
        {!inlineNotificationBtn && renderNotificationBtn()}
        {settingContrl(settingopen)}
      </div>
      {data.map((item) => {
        const CententCom = item.component;
        if (item.flag) {
          if (React.isValidElement(item.component)) {
            return React.cloneElement(item.component, { key: item.id, id: item.id });
          } else {
            return <CententCom key={item.id} id={item.id} />;
          }
        }
        return null;
      })}
    </div>
  );
}

export default withRouter(TabBar);
